import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ServiceNoticesService } from '../core/service-notices.service';

@Component({
  selector: 'app-service-notice-banner',
  standalone: true,
  imports: [CommonModule],
  template: `<section
    class="service-notices"
    aria-label="Service announcements"
    aria-live="polite"
  >
    <article
      *ngFor="let notice of notices.active$ | async"
      [class.restored]="notice.status === 'resolved'"
    >
      <div class="summary">
        <span class="status">{{
          notice.status === 'resolved'
            ? 'SERVICE RESTORED'
            : notice.kind === 'maintenance'
              ? 'SCHEDULED MAINTENANCE'
              : 'SERVICE INCIDENT'
        }}</span>
        <strong>{{ notice.title }}</strong
        ><span
          >{{ notice.startsAt | date: 'medium' }} –
          {{ notice.endsAt | date: 'medium' }} (your local time)</span
        >
      </div>
      <details>
        <summary>Details & instructions</summary>
        <p>{{ notice.message }}</p>
        <p *ngIf="notice.instructions">{{ notice.instructions }}</p>
        <p><a href="https://nosby2007.github.io/innovacare-service-status/" target="_blank" rel="noopener noreferrer">Public service status</a></p>
        <small
          >Expected window. Follow the latest update and your organization’s
          downtime procedures.</small
        >
      </details>
    </article>
  </section>`,
  styles: [
    `
      :host {
        display: block;
      }
      .service-notices:empty {
        display: none;
      }
      article {
        padding: 14px 24px;
        background: #fff4d7;
        border-bottom: 2px solid #d8a43a;
        color: #513700;
        font:
          14px/1.5 Arial,
          sans-serif;
      }
      .summary {
        display: flex;
        align-items: center;
        gap: 14px;
        flex-wrap: wrap;
      }
      .status {
        font-size: 11px;
        font-weight: 800;
        letter-spacing: 0.08em;
      }
      .summary strong {
        font-size: 16px;
      }
      .summary > span:last-child {
        margin-left: auto;
      }
      details {
        margin-top: 6px;
      }
      summary {
        cursor: pointer;
        font-weight: 700;
      }
      p {
        white-space: pre-wrap;
        max-width: 1100px;
      }
      article.restored {
        background: #e5f6ed;
        color: #154c36;
        border-color: #339a6f;
      }
      @media (max-width: 600px) {
        article {
          padding: 12px 16px;
        }
        .summary {
          gap: 5px;
        }
        .summary > span:last-child {
          margin-left: 0;
          width: 100%;
        }
      }
      @media print {
        :host {
          display: none !important;
        }
      }
    `,
  ],
})
export class ServiceNoticeBannerComponent {
  constructor(public notices: ServiceNoticesService) {}
}
